// extracted by mini-css-extract-plugin
export default {"title":"restore_title__I9ZUj","buttonPart":"restore_buttonPart__wsVc4","buttonCancel":"restore_buttonCancel__L2MAn","buttonRestore":"restore_buttonRestore__W5Uhl"};